'use strict';


export const authManagementModule = angular
  .module('app.authManagement', [])
  .config(authManagementConfig);

authManagementConfig.$inject = ['$routeProvider'];

function authManagementConfig($routeProvider) {
  $routeProvider
    .when('/set-new-password', {
      template: '<ngz-set-new-password></ngz-set-new-password>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/', {
      disableCache: true,
      template: '<ngz-sign-in />',
      pageConfig: {
        solution: null,
      },
      resolve: {
          skipIfLoggedIn: ['AuthService', function (AuthService) {
              return AuthService.skipIfLoggedIn();
          }]
      }
    })
    .when('/reset-password', {
      disableCache: true,
      template: '<ngz-forgot-password />',
      pageConfig: {
        solution: null,
      },
      resolve: {
          skipIfLoggedIn: ['AuthService', function (AuthService) {
              return AuthService.skipIfLoggedIn();
          }]
      }
    })
    .when('/password-reset-complete', {
      disableCache: true,
      template: '<ngz-password-reset-complete />',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
      resolve: {
          skipIfLoggedIn: ['AuthService', function (AuthService) {
              return AuthService.skipIfLoggedIn();
          }]
      }
    })
    .when('/access-not-supported', {
      disableCache: true,
      template: '<ngz-access-not-supported></ngz-access-not-supported>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
      resolve: {
        accessNotSupportedRequired: ['AuthService', function (AuthService) {
          return AuthService.accessNotSupportedRequired();
        }],
      },
    });
}
